"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ThumbsUpThin12Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.70788 3.75H9.38094H9.38248H9.70553C11.1733 3.75 12.2481 5.13263 11.886 6.55503L11.0753 9.74004C10.7369 11.0695 9.5398 12 8.16797 12H4.5H3H1.5H0V10.5V6V4.5H1.5H3L4.24359 0.769244C4.39671 0.309859 4.82662 0 5.31085 0H5.34941C6.71031 0 7.8105 1.02968 7.95787 2.32427C7.97868 2.50702 7.9805 2.69504 7.96138 2.8862L7.95787 2.92126L7.88325 3.66754C7.87883 3.71169 7.9135 3.75 7.95787 3.75H8.70788ZM4.5 4.74342V6V10.5H8.16797C8.85388 10.5 9.45242 10.0347 9.62162 9.37002L10.4323 6.18501C10.553 5.71088 10.1948 5.25 9.70553 5.25H7.95787C7.02606 5.25 6.29797 4.44546 6.39069 3.51828L6.46882 2.73694C6.5274 2.15123 6.12739 1.63403 5.57371 1.52229L4.5 4.74342ZM3 6H1.5V10.5H3V6Z", fill: "#131416" }));
}
function ThumbsUpThin12(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ThumbsUpThin12Svg, Object.assign({}, svgProps)));
}
exports.default = ThumbsUpThin12;
//# sourceMappingURL=ThumbsUpThin12.js.map